// THIS FILE IS DUE TO REPLACE THE ORIGINAL index.js
// KEEPING THE ORIGINAL  WHILE I WORK ON THE WHOLE REFACTOR
// WITHOUT BREAKING STUFF

export const SIGN_UP_FORM = 'signUpForm';
export const SOCIAL_SIGN_UP_FORM = 'SocialSignUpForm';
export const LOG_IN_FORM = 'logInForm';
export const CONFIRM_LINKED_ACCOUNT_FORM = 'confirmLinkedAccountForm';
export const LINK_ACCOUNTS_LOG_IN_FORM = 'linkAccountsLogInForm';
export const SET_PASSWORD_FORM = 'setPasswordForm';
export const LINKED_SOFT_ACCOUNTS_FORM = 'LinkedSoftAccountsForm';

// URLs and Paths
export const ACCOUNT_STATUS = 'accountStatus';
export const BASE_URL = '/signin';
export const CONFIRMATION_PATH = 'confirmation';
export const EXISTING_ACCOUNT_PATH = 'existingAccount';
export const LINK_ACCOUNTS_LOG_IN_PATH = 'link_accounts_login';
export const LOG_IN_PATH = 'login';
export const RESET_PASSWORD_PATH = 'resetpassword';
export const RESET_PASSWORD_STATUS_PATH = 'pass-reset';
export const SET_LINKED_SOFT_ACCOUNTS_PATH = 'linkedSoftAccounts';
export const SET_PASSWORD_PATH = 'setpassword';
export const SIGN_UP_PATH = 'signup';
export const SOCIAL_LINK_LOGIN_PATH = 'socialLinkLogin';
export const SOCIAL_LOG_IN_PATH = 'socialLogin';
export const SOCIAL_LOOK_UP_PATH = 'socialLookup';
export const SOCIAL_SIGN_UP_PATH = 'social_signup';
export const SOFT_ACCOUNT_STATUS_PATH = 'pass-set';

export const PASSWORD_SET_TOKEN = 'h';
export const PASSWORD_MUST_LINK_ACCOUNT = 'must_link_account';
export const INVALID_RESET_TOKEN = 'reset_token_invalid';
export const TRIGGER_RESET_PASSWORD = 'triggerReset';

export const CAPTCHA_FIELD = 'captcha';

export const EXTERNAL_USER_EMAIL_ALREADY_USED_ERROR =
    'EXTERNAL_USER_EMAIL_ALREADY_USED';
export const EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT_ERROR =
    'EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT';
export const EXTERNAL_USER_WITHOUT_EMAIL_ERROR = 'EXTERNAL_USER_WITHOUT_EMAIL';
export const EMAIL_PERMISSION_DENIED_ERROR = 'EMAIL_PERMISSION_DENIED';
export const TOKEN_NOT_AUTHORIZED_ERROR = 'TOKEN_NOT_AUTHORIZED';
export const EXTERNAL_USER_UNKNOWN_ERROR = 'EXTERNAL_USER_UNKNOWN';
export const INVALID_SOCIAL_LOGIN_FIELD = 'INVALID_SOCIAL_LOGIN_FIELD';
export const SUSPENDED_ACCOUNT = 'SUSPENDED_ACCOUNT';
export const ARGUMENTS_ERROR = 'ARGUMENTS_ERROR';
export const EXTERNAL_UNKNOWN_ERROR = 'EXTERNAL_UNKNOWN_ERROR';

export const STATUS_TYPES = [
    RESET_PASSWORD_STATUS_PATH,
    SOFT_ACCOUNT_STATUS_PATH,
];

export const ONBOARDING_REDIRECT_URL_BLACKLIST = [
    'create',
    'oauth',
    'organizations',
];

/**********************      TRACKING CONSTANTS     **************************/

export const GA_AUTH_CATEGORY = 'signin';
export const GA_ENTER_EMAIL_EVENT = 'EnterEmail';
export const GA_EDIT_EMAIL_EVENT = 'EmailEdited';
export const GA_EDIT_EMAIL_MISMATCH = 'EditEmailMismatch';
export const GA_SIGNUP_EVENT = 'Signup';
export const GA_LOGIN_EVENT = 'Login';
export const GA_LOGIN_INSTEAD_CLICKED_EVENT = 'ClickLoginInstead';
export const GA_CONFIRM_EMAIL_SHOWED = 'ReEnterEmail';
export const GA_SOCIAL_SIGNUP_EVENT = 'SocialSignUp';
export const GA_FORGOT_PASSWORD_EVENT = 'ForgotPwd';
export const GA_CHECK_EMAIL_PROMPT_EVENT = 'CheckEmailPrompt';
export const GA_SET_PASSWORD_EVENT = 'SetPassword';
export const GA_RESET_PASSWORD_EVENT = 'ResetPassword';
export const GA_LOGIN_INVALID_PASSWORD = 'LoginInvalidPassword';
export const GA_FB_LOGIN_BUTTON_CLICKED_EVENT = 'FBLogin_Clicked';
export const GA_APPLE_LOGIN_BUTTON_CLICKED_EVENT = 'SIWA_Clicked';
export const GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB = 'FBLogin_NotLoggedInToFB';
export const GA_FB_LOGIN_LOGGED_IN_TO_FB = 'FBLogin_LoggedInToFB';
export const GA_FB_LOGIN_PERMISSIONS_NOT_GRANTED =
    'FBLogin_PermissionsNotGranted';
export const GA_FB_LOGIN_NO_EMAIL_ADDRESS = 'FBLogin_NoEmailAddress';
export const GA_FB_LOGIN_EMAIL_NOT_SHARED = 'FBLogin_EmailNotShared';
export const GA_FB_LOGIN_EMAIL_ALREADY_EXISTS = 'FBLogin_EmailAlreadyExists';
export const GA_FB_LOGIN_EMAIL_ALREADY_EXISTS_ON_SOFT_ACCOUNT =
    'FBLogin_EmailAlreadyExistsOnSoftAccount';
export const GA_FB_LOGIN_EXTERNAL_USER_UNKNOWN = 'FBLogin_ExternalUserUnknown';
export const GA_FB_LOGIN_ACCOUNT_CREATED = 'FBLogin_AccountCreated';
export const GA_FB_LOGIN_ACCOUNT_LINKING_FAILED =
    'FBLogin_AccountLinkingFailed';
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE =
    'GetStarted_AlreadyConnectedToApple';
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_FB =
    'GetStarted_AlreadyConnectedToAppleAndFacebook';
export const GA_GET_STARTED_CLICKED = 'GetStarted_Clicked';
export const GA_TOS_CLICKED = 'TOS_Clicked';
export const GA_COMUNITY_GUIDELINES_CLICKED = 'ComunityGuidelines_Clicked';
export const GA_PRIVACY_POLICY_CLICKED = 'PrivacyPolicy_Clicked';
export const GA_CONFIRMATION_ACKNOWLEDGED = 'SignInConfirmationAcknowledged';
export const GA_CONFIRMATION_REJECTED = 'SignInConfirmationRejected';

export const GA_EXISTING_ACCT_LABEL = 'existing account';
export const GA_SOFT_ACCT_LABEL = 'soft account';
export const GA_NEW_ACCT_LABEL = 'new account';
export const GA_RE_ENTER_EMAIL_LABEL = 'Re-enter email';
